import { Form, Select } from "antd";

const CONSENT_OPTIONS = [
  { label: "Has Consent", value: "consent" },
  { label: "No Consent", value: "no_consent" },
  { label: "Unknown", value: "unknown" },
];

function ConsentCheckboxFilter({ label, name }) {
  return (
    <Form.Item label={label} name={name}>
      <Select
        mode="multiple"
        allowClear
        popupMatchSelectWidth={false}
        options={CONSENT_OPTIONS}
        placeholder="Select consent status..."
      />
    </Form.Item>
  );
}

export default ConsentCheckboxFilter;
